import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "../Button/Button.css";

export default function LinkButton({
  children,
  isDisabled,
  className,
  type,
  ...rest
}) {
  return (
    <Link
      className={classNames(
        styles.button,
        styles[type || "primary"],
        { [styles.disabled]: isDisabled },
        className // additional classes passed through in props
      )}
      aria-disabled={isDisabled}
      onClick={isDisabled ? e => e.preventDefault() : undefined}
      {...rest}
    >
      {children}
    </Link>
  );
}

/* See <Button> */
LinkButton.propTypes = {
  type: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "submit",
    "cancel",
  ]),
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
};
